var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69021 14.4572C9.71554 14.5203 9.75957 14.5742 9.81639 14.6116C9.87322 14.6489 9.94011 14.668 10.0081 14.6663C10.0761 14.6646 10.1419 14.6421 10.1968 14.6018C10.2516 14.5616 10.2928 14.5055 10.3149 14.4412L14.6482 1.77454C14.6695 1.71547 14.6736 1.65154 14.66 1.59024C14.6463 1.52894 14.6154 1.4728 14.571 1.42839C14.5266 1.38398 14.4705 1.35314 14.4092 1.33947C14.3479 1.3258 14.2839 1.32987 14.2249 1.35121L1.55821 5.68454C1.49388 5.7066 1.43783 5.74782 1.39759 5.80266C1.35736 5.85749 1.33486 5.92332 1.33312 5.99131C1.33138 6.05931 1.35047 6.1262 1.38785 6.18303C1.42523 6.23985 1.47909 6.28388 1.54221 6.30921L6.82888 8.42921C6.996 8.49612 7.14785 8.59618 7.27526 8.72336C7.40266 8.85054 7.503 9.0022 7.57021 9.16921L9.69021 14.4572Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5697 1.4314L7.27637 8.72406",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.6e23da94f3db8b6606aa2ca03dd9d978.svg";
export { ForwardRef as ReactComponent };